import ViewArticleHighlights from '../implementations/View/ArticleHighlights';
import ViewArticleRelated from '../implementations/View/ArticleRelated';
import ViewArticlesOverview from '../implementations/View/ArticlesOverview';
import ViewArticlesFiltered from '../implementations/View/ArticlesFiltered';
import ViewDocsByTheme from '../implementations/View/DocsByTheme';
import ViewEventsUpcoming from '../implementations/View/EventsUpcoming';
import ViewMediaFiltered from '../implementations/View/MediaFiltered';
import ViewMediaPersonsFiltered from '../implementations/View/PersonsFiltered';
import ViewPartnersHighlights from '../implementations/View/PartnersHighlights';
import ViewPartnersOverview from '../implementations/View/PartnersOverview';
import ViewProjectsFiltered from '../implementations/View/ProjectsFiltered';
import ViewVacanciesFiltered from '../implementations/View/VacanciesFiltered';

const mappers = {
  views_block__article_highlights: ViewArticleHighlights,
  views_block__article_overview: ViewArticlesOverview,
  views_block__article_related: ViewArticleRelated,
  views_block__articles_filtered_articles_filtered: ViewArticlesFiltered,
  views_block__docs_by_theme: ViewDocsByTheme,
  views_block__events_upcoming: ViewEventsUpcoming,
  views_block__media_filtered_media_filtered: ViewMediaFiltered,
  views_block__partners_highlights: ViewPartnersHighlights,
  views_block__partners_overview: ViewPartnersOverview,
  views_block__persons_filtered_persons_filtered: ViewMediaPersonsFiltered,
  views_block__projects_filtered_projects_filtered: ViewProjectsFiltered,
  views_block__vacancies_filtered_vacancies_filtered: ViewVacanciesFiltered,
};

export default mappers;
